window.HMAPCommunicationHubSettingsForm = function ($scope, brand) {
    var self = this;

    self.brandId = brand.id;
};
